<mat-dialog-content>
  <div class="container" style="margin-top:15px;">
    <div class="row">
      <div class="col-3" style="padding-right: calc(var(--bs-gutter-x) * 0.2); padding-left: calc(var(--bs-gutter-x) * 0.2);">
        <mat-form-field class="text-center">
          <input #vf0
                 matInput
                 type="tel"
                 [(ngModel)]="verificationCode0"
                 autocomplete="off"
                 maxlength="1"
                 class="text-center"
                 (keyup)="focusNext(0, $event)" />
        </mat-form-field>
      </div>
      <div class="col-3" style="padding-right: calc(var(--bs-gutter-x) * 0.2); padding-left: calc(var(--bs-gutter-x) * 0.2);">
        <mat-form-field class="text-center">
          <input #vf1
                 matInput
                 type="tel"
                 [(ngModel)]="verificationCode1"
                 autocomplete="off"
                 maxlength="1"
                 class="text-center"
                 (keyup)="focusNext(1, $event)" />
        </mat-form-field>
      </div>
      <div class="col-3" style="padding-right: calc(var(--bs-gutter-x) * 0.2); padding-left: calc(var(--bs-gutter-x) * 0.2);">
        <mat-form-field class="text-center">
          <input #vf2
                 matInput
                 type="tel"
                 [(ngModel)]="verificationCode2"
                 autocomplete="off"
                 maxlength="1"
                 class="text-center"
                 (keyup)="focusNext(2, $event)" />
        </mat-form-field>
      </div>
      <div class="col-3" style="padding-right: calc(var(--bs-gutter-x) * 0.2); padding-left: calc(var(--bs-gutter-x) * 0.2);">
        <mat-form-field class="text-center">
          <input #vf3
                 matInput
                 type="tel"
                 [(ngModel)]="verificationCode3"
                 autocomplete="off"
                 maxlength="1"
                 class="text-center"
                 (keyup)="focusNext(3, $event)" />
        </mat-form-field>
      </div>
    </div>
  </div>
  </mat-dialog-content>
<mat-dialog-actions style="margin: auto; margin-bottom: 15px;">
  <button mat-raised-button style="margin: 2px;" [mat-dialog-close]="false">{{ 'turbo.core.PromptDialog.cmdCancel' | translate : 'Cancel' }}</button>
</mat-dialog-actions>
